import { ClaimShape } from '@/assets/images'
import { MarketingButton } from '@/components/ui/marketing-button'

/**
 * DISABLED ON PURPOSE — do not wire this up until a real lead-capture endpoint exists.
 *
 * Legacy rendered this as a live-looking email form with a submit button and NO handler and NO
 * action: pressing "Sign Up" reloaded the page and the address went nowhere. No endpoint for it
 * exists in the new platform either (every BFF surface is auth-gated; verified by curl —
 * docs/features/landing-coverage.md, "Forms"). Rather than reproduce a control that swallows an
 * email address while looking like it worked, the input and button render disabled with a
 * visible note. When a lead endpoint lands: enable, POST to it, and show real success/failure.
 */
export function ClaimSection() {
  return (
    <section className="claim-section">
      <div className="claim-section-inner">
        <img src={ClaimShape} alt="" />

        <h6>Claim your free employer profile</h6>

        <form aria-disabled="true">
          <input type="email" placeholder="Your email" disabled aria-label="Your email" />
          <MarketingButton type="submit" disabled>
            Sign Up
          </MarketingButton>
        </form>

        <p className="claim-section-note">Sign-up by email is not available yet.</p>
      </div>
    </section>
  )
}
